import { SensorTable } from "@/components/sensor-table";

export default function DataExplorerPage() {
  return (
    <div className="p-4 space-y-4 md:p-6">
      <h1 className="text-2xl font-semibold text-[#1E293B]">Data Explorer</h1>
      <SensorTable />
    </div>
  );
}
